import React from 'react';
import { UnitPreference, kmToUnit, distanceUnitLabel } from '../../utils/units';
import './OdometerDisplay.css';

interface Props {
  km: number;
  unit: UnitPreference;
}

export default function OdometerDisplay({ km, unit }: Props) {
  const digits = String(Math.round(kmToUnit(km, unit))).padStart(6, '0').split('');
  return (
    <span className="odometer-display">
      {digits.map((digit, i) => (
        <span className="odometer-digit" key={i}>{digit}</span>
      ))}
      <span className="odometer-unit">{distanceUnitLabel(unit)}</span>
    </span>
  );
}
